import { render, staticRenderFns } from "./FinalExamRootView.vue?vue&type=template&id=bfc58a14"
import script from "./FinalExamRootView.vue?vue&type=script&lang=js"
export * from "./FinalExamRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports